import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/redo-requests/searchbar";
import RedoRequestTable from "../../../containers/admin/redo-requests/table";
import { editRedoRequestRequest, getAllRedoRequestsRequest } from "../../../modules/admin-modules/redo-requests/Actions";

const RedoRequests = () => {
  const dispatch = useDispatch();
  const redoRequests = useSelector((state) => state.redoRequests.redoRequests);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllRedoRequestsRequest());
  }, [dispatch]);

  const handelAcceptAll = () => {
    const formData = new FormData();
    redoRequests?.forEach((request, index) => {
      formData.append(`requests[${index}]`, request?.id);
    });
    dispatch(editRedoRequestRequest(formData));
  };

  return (
    <Layout>
      <SearchBar handelAcceptAll={handelAcceptAll} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <RedoRequestTable searchTerm={searchTerm} />
    </Layout>
  );
};

export default RedoRequests;
